import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEnquiryForm } from "@/hooks/useEnquiryForm";
import {
  EnquiryTypeField,
  HoneypotField,
  MessageField,
  TextField,
} from "@/components/landing/ContactFormFields";

const SubmitRow = ({ submitting }) => (
  <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
    <Button
      type="submit"
      size="lg"
      disabled={submitting}
      data-testid="contact-form-submit-button"
      className="w-full bg-[#148a8f] text-white transition-colors hover:bg-[#0f6e73] disabled:opacity-70 sm:w-auto"
    >
      {submitting ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Sending…
        </>
      ) : (
        "Send enquiry"
      )}
    </Button>
    <p className="text-xs text-slate-500">
      We use your details only to respond to this enquiry.
    </p>
  </div>
);

export const ContactForm = ({ onSuccess }) => {
  const { form, errors, submitting, setField, submit } = useEnquiryForm(onSuccess);

  return (
    <form onSubmit={submit} data-testid="contact-enquiry-form" noValidate className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <TextField
          id="full_name"
          label="Full name"
          required
          testId="contact-form-full-name-input"
          placeholder="e.g. Aisha Rahman"
          value={form.full_name}
          error={errors.full_name}
          onChange={(value) => setField("full_name", value)}
        />
        <TextField
          id="email"
          label="Email"
          type="email"
          required
          testId="contact-form-email-input"
          placeholder="you@example.com"
          value={form.email}
          error={errors.email}
          onChange={(value) => setField("email", value)}
        />
        <TextField
          id="phone"
          label="Phone / WhatsApp"
          testId="contact-form-phone-input"
          placeholder="+971 50 000 0000"
          value={form.phone}
          error={errors.phone}
          onChange={(value) => setField("phone", value)}
        />
        <EnquiryTypeField
          value={form.service}
          error={errors.service}
          onChange={(value) => setField("service", value)}
        />
      </div>

      <MessageField
        value={form.message}
        error={errors.message}
        onChange={(value) => setField("message", value)}
      />

      <HoneypotField
        value={form.company_website}
        onChange={(value) => setField("company_website", value)}
      />

      {errors.form ? (
        <p className="text-sm text-red-600" data-testid="contact-form-error">
          {errors.form}
        </p>
      ) : null}

      <SubmitRow submitting={submitting} />
    </form>
  );
};
